<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-b" data-toggle="modal" data-target="#exampleModal">Add</button>
            <div class="personal-details">
                <h4 class="personal-details-title">Service List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th style="width: 10%;">Service Id</th>
                      <th style="width: 15%;">Name</th>
                      <th style="width: 40%;">Description</th>
                      <th style="width: 10%;">Image</th>
                      <th style="width: 15%;">Date</th>
                      <th style="width: 10%;">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of serviceData; let i=index">
                      <th>{{x.serviceId}}</th>
                      <th >{{x.name}}</th>
                      <th >{{x.description}}</th>
                      <th >
                        <img *ngIf="x.imageUrl != ''" width="60" height="60" src="{{x.imageUrl}}" alt="">
                      </th>
                      <th >{{x.createdDate | date : 'dd/MM/yyyy'}}</th>
                      <th class="action-button"> 
                        <i class="bi bi-trash3" data-toggle="modal" data-target="#deleteModal" (click)="selectServiceId(x.serviceDefinitionId)"></i>
                        <i class="bi bi-eye-fill" data-toggle="modal" data-target="#viewModal" (click)="getServiceById(x.serviceDefinitionId)"></i>
                      </th>
                    </tr>
                  </tbody>
                </table>
            </div> -->

            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Service List</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                          <input [ngModelOptions]="{standalone: true}" placeholder="search user" [(ngModel)]="searchUser"/>
                      </form>
                      <i class="bi bi-search" (click)="getServiceDefinitionByWildSearch(0,10)"></i>
                    </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 10%;">Id</th>
                        <th style="width: 15%;">Name</th>
                        <th style="width: 40%;">Description</th>
                        <th style="width: 10%;">Image</th>
                        <th style="width: 15%;">Date</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let service of serviceData | paginate : {
                      itemsPerPage: recordsPerPage,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 10%;">{{service.serviceId}}</p>
                      <p style="width: 15%;">{{service.name}}</p>
                      <p style="width: 40%;">{{service.description}}</p>
                      <p style="width: 10%;">
                        <img width="40" height="40" [src]="service.imageUrl ? service.imageUrl : 'assets/img/dummy.png'" alt="Service Image">
                      </p>
                      <p style="width: 15%;">{{service.createdDate | date : 'dd/MM/yyyy'}}</p>
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                          <i *ngIf="actionControls.isView" data-toggle="modal" data-target="#viewModal" (click)="getServiceById(service.serviceDefinitionId)" class="bi bi-eye-fill"></i>
                          <i *ngIf="actionControls.isDelete" data-toggle="modal" data-target="#deleteModal" (click)="selectServiceId(service.id)" class="bi bi-trash3"></i>
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && serviceData.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="recordsPerPage" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Service
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="form-group">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <label>Service Id <span class="required-field">*</span></label>
                        <input formControlName="serviceId" type="text" class="form-control">
                        <span class="err" *ngIf="form.get('serviceId').invalid && formSubmit">service id required</span>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <label>Service Name <span class="required-field">*</span></label>
                        <input formControlName="name" type="text" class="form-control">
                        <span class="err" *ngIf="form.get('name').invalid && formSubmit">service name required</span>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <label>Description</label>
                        <input formControlName="description" type="text" class="form-control">
                        <span class="err" *ngIf="form.get('description').invalid && formSubmit">description required</span>
                    </div>
                    
                    <div class="col-md-12 col-lg-12" hidden="true">
                        <label>Image <span class="required-field">*</span></label>
                        <input id="add-image-btn" type="file" accept="image/*" hidden="true" (change)="onChange($event)"> class="form-control">
                        <span class="err" *ngIf="form.get('imageUrl').invalid && formSubmit">image required</span>
                    </div>

                    <div class="col-md-12 col-lg-12">
                        <label>Image <span class="required-field">*</span></label><br>
                        <img *ngIf="form.get('imageUrl').value != ''" width="70" height="70" src="{{form.get('imageUrl').value}}" alt="">
                        <br>
                        <button (click)="addImageBtn()" class="btn btn-primary">Add Image</button>
                        <span class="err" *ngIf="form.get('imageUrl').invalid && formSubmit">image required</span>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
              <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">Cancel</button>
              <button type="button" (click)="addService()" class="btn btn-primary">Add Service</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Service Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleServiceData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <label>Service Id :</label>
                <p>{{viewData.serviceId}}</p>
              </div>
              <div class="col-md-12 col-lg-12">
                <label>Service Name :</label>
                <p>{{viewData.name}}</p>
              </div>
              <div class="col-md-12 col-lg-12">
                <label>Service Description :</label>
                <p>{{viewData.description}}</p>
              </div>
              <div class="col-md-12 col-lg-12">
                <label>Service Image :</label><br>
                <img width="70" height="70" [src]="viewData.imageUrl ? viewData.imageUrl : 'assets/img/dummy.png'" alt="Service Image">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Conformation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>   
      <div class="modal-footer">
        <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="deleteService()">Delete</button>
      </div>
      </div>
    </div>
  </div>
</div>